import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscription, switchMap } from 'rxjs';
import { CurrentUser } from "../../common/providers/current-user";
import { FeedbackProvider } from '../providers/feedback-provider';
import { map } from "rxjs/operators";
import { OrganizationsProvider } from "../../organizations/providers/organizations-provider";

@Injectable({
    providedIn: 'root'
})
export class CanActivateDailyFeedbackAnswered implements CanActivate {

    constructor(
        private router: Router,
        private currentUser: CurrentUser,
        private feedbackProvider: FeedbackProvider,
        private organizationsProvider: OrganizationsProvider,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const organizationCode = route.params['organizationCode'];
      const athleteUserId = route.params['athleteId'];

      if (!this.currentUser || !this.currentUser?.user) {
          return true;
      }
      return this.organizationsProvider.getByCode(organizationCode).pipe(
        switchMap((organization) => {
          return this.feedbackProvider.hasAnsweredDailyFeedback(organization.id!, athleteUserId, this.currentUser.user?.id!).pipe(
            map((hasAnswered) => {
              if (!hasAnswered) {
                this.router.navigateByUrl('/' + organizationCode + '/app/athletes/' + athleteUserId + '/feedback/daily/new');
                return false;
              }
              return true;
            }),
          );
        })
      );
    }

}
